<div class="d-flex d-sm-none">
  <a class="ds-btn"></a>
</div>
<div class="d-flex justify-content-center align-items-center">
  <button
    (click)="selectFirst()"
    type="button"
    [disabled]="disabled || value <= 0"
    class="btn btn-outline-primary d-flex justify-content-center align-items-center ps-3 me-3"
  >
    <em class="ds-icon ds-icon--big ds-icon--arrow-first"></em>
    <span>{{firstTitle}}</span>
  </button>
  <button
    (click)="selectPrevious()"
    type="button"
    [disabled]="disabled || value <= 0"
    class="btn btn-primary d-flex justify-content-center align-items-center ps-3 me-4"
  >
    <em class="ds-icon ds-icon--big ds-icon--arrow-left"></em>
    <span>{{previousTitle}}</span>
  </button>
  <span>{{pageTitle}}</span>
  <span class="mx-2">{{value + 1}}</span>
  <span>{{ofTitle}}</span>
  <span class="ms-1">{{lastPageIndex + 1}}</span>
  <button
    (click)="selectNext()"
    type="button"
    [disabled]="disabled || value >= lastPageIndex"
    class="btn btn-primary d-flex justify-content-center align-items-center pe-3 ms-4"
  >
    <span>{{nextTitle}}</span>
    <em class="ds-icon ds-icon--big ds-icon--arrow-right"></em>
  </button>
  <button
    (click)="selectLast()"
    type="button"
    [disabled]="disabled || value >= lastPageIndex"
    class="btn btn-outline-primary d-flex justify-content-center align-items-center pe-3 ms-3"
  >
    <span>{{lastTitle}}</span>
    <em class="ds-icon ds-icon--big ds-icon--arrow-last"></em>
  </button>
</div>
